import axios from 'axios';
axios.defaults.headers.common['RequestVerificationToken'] = window.globals.Token;
axios.defaults.headers.common['Ref_PageID'] = window.globals.pageId;

(() => {
	// Display login modal in checkout
	const loginToggle = document.querySelector('#login-modal-target-checkout');
	if(loginToggle) {
		loginToggle.addEventListener('click', e => {
			e.preventDefault();
			window.EventBus.$emit('open-modal', 'login');
		});
	}

	//Check if user want to sign up for the newsletter
	const NewsletterSignUp = document.getElementById('EcomOrderSubscribeToNewsletter');
	const CheckForAccount = document.getElementById('EcomUserCreateNew');

	if (NewsletterSignUp && CheckForAccount) {
		NewsletterSignUp.addEventListener('change', check => {
			if (check.currentTarget.checked) {
				document.getElementById('EcomUserCreateNew').checked = true;
				passwordFields.classList.remove('hidden');
			}
		});
	}

	// Display new account username & password fields if checkbox is selected
	const newAccountToggle = document.querySelector('#EcomUserCreateNew');
	const passwordFields = document.querySelector('#newAccountPasswordFields');
	if(newAccountToggle) {
		const usernameField = passwordFields.querySelector('[name="EcomUserCreateUserName"]');
		const emailField = document.querySelector('[name="EcomOrderCustomerEmail"]');
		const passwordNormalField = passwordFields.querySelector('[name="EcomUserCreatePassword"]');
		const passwordConfirmField = passwordFields.querySelector('[name="EcomUserCreateConfirmPassword"]');

		// Set username as email field
		usernameField.value = emailField.value;

		// Listen to changes in email field and update username
		emailField.addEventListener('change', e => {
			usernameField.value = e.target.value;
		});

		newAccountToggle.addEventListener('change', e => {
			if(e.target.checked) {
				// Set minchar attributes on password fields to make them required
				passwordNormalField.setAttribute('minchar', '6');
				passwordConfirmField.setAttribute('minchar', '6');
				passwordNormalField.setAttribute('type', 'password');
				passwordConfirmField.setAttribute('type', 'password');
				
				// Set username as email field
				usernameField.value = emailField.value;
				
				// Listen to changes in email field and update username
				emailField.addEventListener('change', e => {
					usernameField.value = e.target.value;
				});
				
				// Remove hidden state on wrapper
				passwordFields.classList.remove('hidden');
			} else {
				// Remove minchar attributes to make fields not required in validation
				passwordNormalField.removeAttribute('minchar');
				passwordConfirmField.removeAttribute('minchar');
				passwordNormalField.setAttribute('type', 'hidden');
				passwordConfirmField.setAttribute('type', 'hidden');

				// Reset username field
				usernameField.value = '';

				// Remove event listener on emailfield
				emailField.removeEventListener('change', e => {
					usernameField.value = e.target.value;
				});

				// Hide password fields
				passwordFields.classList.add('hidden');
				document.getElementById('EcomOrderSubscribeToNewsletter').checked = false;
			}
		});
	}

	// Set required fields on delivery address if selected
	const deliveryAddressTrigger = document.querySelector('.delivery-address__trigger');
	const deliveryAddressForm = document.querySelector('.delivery-address__form');
	if(deliveryAddressForm && deliveryAddressTrigger) {
			
		const requiredDeliveryFields = [
			'EcomOrderDeliveryName',
			'EcomOrderDeliveryFirstname',
			'EcomOrderDeliverySurname',
			'EcomOrderDeliveryEmail',
			'EcomOrderDeliveryAddress',
			'EcomOrderDeliveryHouseNumber',
			'EcomOrderDeliveryCity',
			'EcomOrderDeliveryZip',
			'EcomOrderDeliveryCountryCode'
		];

		const optionalDeliveryFields = [
			'EcomOrderDeliveryCompany',
			'EcomOrderDeliveryPhone',
			'EcomOrderDeliveryAddress2'
		];

		deliveryAddressTrigger.addEventListener('click', () => {
			toggleRequiredFields();
			getCustomerDeliveryCountryData();
		});

		const toggleRequiredFields = () => {
			if(deliveryAddressForm.classList.contains('delivery-address__form--active')) {
				// Deactivate required fields and block
				deliveryAddressForm.classList.remove('delivery-address__form--active');
				requiredDeliveryFields.forEach(fieldName => {
					const field = document.querySelector(`[name='${fieldName}']`);
					if(field) {
						if(field.hasAttribute('verplicht')) {
							field.removeAttribute('verplicht');
						}
						if(field.hasAttribute('minchar')) {	
							field.removeAttribute('minchar');
						}
						if(fieldName === 'EcomOrderDeliveryZip') {
							field.removeAttribute('valtype');
						}
						field.value = '';
					}
				});
				optionalDeliveryFields.forEach(fieldName => {
					const field = document.querySelector(`[name='${fieldName}']`);
					if(field) {
						field.value = '';
					}
				});
			} else {
				// Activate required fields and block
				deliveryAddressForm.classList.add('delivery-address__form--active');
				requiredDeliveryFields.forEach(fieldName => {
					const field = document.querySelector(`[name='${fieldName}']`);
					if(field) {
						field.setAttribute('verplicht', 'verplicht');
						field.setAttribute('minchar', '1');
						if(fieldName === 'EcomOrderDeliveryZip') {
							field.setAttribute('valtype', 'zipcode');
						}
					}
				});
			}
		};
	}

	const customerCountryInput = document.querySelector('[name="EcomOrderCustomerCountryCode"]');
	const deliveryCountryInput = document.querySelector('[name="EcomOrderDeliveryCountryCode"]');

	const setShippingCountry = async countryObj => {
		try {
			let { data } = await axios.post('/api/ShoppingCart/Countries/', countryObj);
			window.EventBus.$emit('set-shoppingcart', data);
		} catch(err) {
			console.log(err);
		}
	};

	const getCustomerDeliveryCountryData = () => {
		const useDeliveryAdress = deliveryAddressForm.classList.contains('delivery-address__form--active');
		const data = {
			'customerCountry': customerCountryInput ? customerCountryInput.value : '',
			'deliveryCountry': deliveryCountryInput && useDeliveryAdress ? deliveryCountryInput.value : '',
			'useDeliveryAdress': useDeliveryAdress
		};
		setShippingCountry(data);
	};

	if(customerCountryInput) {
		if(customerCountryInput.value) {
			getCustomerDeliveryCountryData();
		}
		customerCountryInput.addEventListener('change', function() {
			getCustomerDeliveryCountryData();
		});
	}

	if(deliveryCountryInput) {
		deliveryCountryInput.addEventListener('change', function() {
			getCustomerDeliveryCountryData();
		});
	}

	const finalStep = document.querySelector('.checkout-form__submitbtn--forward.final-step');
	const termsAcceptEl = document.querySelector('[type="checkbox"]#EcomOrderCustomerAccepted');
	
	if(finalStep) {
		finalStep.addEventListener('click', () => {
			const termsAcceptIsChecked = termsAcceptEl ? termsAcceptEl.checked : true;
			if(termsAcceptIsChecked) {
				finalStep.style.pointerEvents = 'none';
				const btnIcon = finalStep.querySelector('.btn__icon');
				finalStep.classList.add('btn--disabled');
				btnIcon.classList.remove('fa-chevron-right');
				btnIcon.classList.add('fa-spinner-third', 'fa-spin');
				
				setTimeout(() => {
					finalStep.style.pointerEvents = 'auto';
					finalStep.classList.remove('btn--disabled');
					btnIcon.classList.add('fa-chevron-right');
					btnIcon.classList.remove('fa-spinner-third', 'fa-spin');
				}, 3000);
			}

		});
	}

})();
